import { render, staticRenderFns } from "./OrderByTeamComponent.vue?vue&type=template&id=2c961b68&"
import script from "./OrderByTeamComponent.vue?vue&type=script&lang=js&"
export * from "./OrderByTeamComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports